import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import { PenIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import { Skeleton } from '@repo/ui/skeleton'
import Typography from '@repo/ui/typography'
import { PropsWithChildren } from 'react'

type Props = {
  className?: string
  title?: string
  subTitle?: string
  isLoading?: boolean
  disabled?: boolean
  onEditClick?: () => void
}

const DetailsEditCard = ({
  className,
  title,
  subTitle,
  children,
  isLoading,
  disabled,
  onEditClick
}: PropsWithChildren<Props>) => {
  if (isLoading) return <Skeleton className={'h-60'} />

  return (
    <InnerBox className={cn('p-3 rounded-lg')}>
      <div className="flex items-center justify-between w-full">
        <div className="flex gap-2 items-center">
          <Typography variant="body-medium" color={tailwindColors.primary.DEFAULT}>
            {title}
          </Typography>
          {subTitle && <Badge text={subTitle} variant="primary" size="small" className="h-6" />}
        </div>
        {!disabled && (
          <PenIcon
            color={tailwindColors.primary.DEFAULT}
            color2={tailwindColors.primary.DEFAULT}
            className="cursor-pointer hover:opacity-70"
            onClick={onEditClick}
          />
        )}
      </div>
      <div className="h-4" />
      <div className={className}>{children}</div>
    </InnerBox>
  )
}

export default DetailsEditCard
